export default __webpack_public_path__ + "assets/images/twitter-x-ab3e4df9062dc799c057fdcb6ad4f5b4.svg";